<div>
  <div class="col-12 cms__head">
    <div class="col-12">
      <div class="cms__title">
        <div>
          <h2 class="cms__title-text">
            {{ title }}
          </h2>

          <h4 class="cms__title-help-text">
            {{ titleHelpText }}
          </h4>
        </div>

        <ng-content select="[actions]"></ng-content>
      </div>

      <ng-content select="[mainNavigation]"></ng-content>
    </div>
  </div>
  <div class="col-12 p-3 mb-3 cms__content">
    <div class="col-12">
        <ng-content select="[content]"></ng-content>
    </div>
  </div>
</div>
